var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLuxonShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6bff3b;}.cls-2{fill:#14635b;}.cls-3{fill:#283331;}.cls-4{fill:#1c7f78;}.cls-5{fill:aqua;}.cls-6{fill:#003834;}.cls-7{fill:#0f4c45;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "629.42 422.15 596.99 427.02 529.51 427.02 529.51 369.59 629.42 384.59 629.42 422.15"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "569.12 451.57 84.94 451.57 29 439.76 571.89 434 569.12 451.57"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.1 410.92 29 439.76 574.04 433.67 628.38 345.91 140.1 410.92"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "663.62 530.24 339.86 505.97 321.73 492.03 658.35 514.53 663.62 530.24"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "455.5 482.98 210.84 473.21 210.84 465.95 455.5 456.18 455.5 482.98"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "628.73 346.28 50.77 320.66 28.95 176.4 628.73 346.28"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.59 377.6 15.66 266.56 628.73 346.28 35.59 377.6"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "658.83 514.53 322.18 492.49 292.78 436.44 573.68 434 658.83 514.53"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "628.73 346.28 28.95 440.23 3.32 358.62 628.73 346.28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLuxonShip);
export default __webpack_public_path__ + "static/media/mob-luxon-ship.ab4441ce8393c7adaa83d4486ffa443f.svg";
export { ForwardRef as ReactComponent };